export { default } from "./BagMessage";
